<!--
    描述：用户组
    日期：2021/04/27
    作者：zwh
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>角色列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   size="small"
							   icon="el-icon-check"
							   v-if="roleBtns.includes('group_role_add')"
							   @click="doClick('', 'add')">新增
					</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="content">
						<el-table :data="treeObj.data"
								  row-key="id"
								  v-loading="treeObj.loading"
								  ref="tree"
								  default-expand-all
								  :height="treeObj.tableH"
								  border
								  highlight-current-row
								  @row-click="rowClick"
								  :tree-props="{ children: 'children' }">
							<el-table-column prop="roleName"
											 label="角色名称"
											 align="center"
											 header-align="center"
											 show-overflow-tooltip
											 min-width="130"></el-table-column>
							<el-table-column prop="roleTypeName"
											 label="角色类型"
											 align="center"
											 show-overflow-tooltip
											 min-width="130">
								<template slot="header"
										  slot-scope="scope">
									<div>角色类型
										<el-tooltip effect="light"
													placement="top">
											<div slot="content">
												角色类型：创建角色时指定角色类型以适配项目管理系统作业内外角色权限。</br>
												项目外公共角色：管理员创建，用于项目管理系统操作角色权限。
											</div>
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
								</template>
								<template slot-scope="scope">
									<span
										  v-show="scope.row.roleType ==='1007001' && scope.row.limitId == null">项目内公共角色</span>
									<span
										  v-show="scope.row.roleType ==='1007001' && scope.row.limitId != null">项目内主体公共角色</span>
									<span v-show="scope.row.roleType ==='1007002'">项目内主体私有角色</span>
								</template>
							</el-table-column>
							<el-table-column prop="limitName"
											 v-if="userInfo.roleType === 1"
											 label="主体类型"
											 align="center"
											 header-align="center"
											 show-overflow-tooltip
											 min-width="130"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 show-overflow-tooltip
											 min-width="105">
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
											   v-if="roleBtns.includes('group_role_edit')"
											   type="text"
											   :disabled="scope.row.roleType === '1007001' && userInfo.roleType !== 1"
											   @click="doClick(scope.row, 'edit')"></el-button>
									<el-button v-if="roleBtns.includes('group_role_delete')"
											   size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   :disabled="scope.row.roleType === '1007001' && userInfo.roleType !== 1"
											   @click="doClick(scope.row, 'delete')"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 弹窗组件 -->
			<roleAdd ref="roleAdd"
					 v-if="dialogObj.visible"
					 :mode="dialogObj.mode"
					 :transObj="transObj"
					 @handle-success="handleSuccess"></roleAdd>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import roleAdd from './role_add_dialog'
import { getProjectRoles, deletePlus } from 'api/system/sysGroupInnerRole.js'
export default {
	name: '',
	components: {
		roleAdd,
	},
	data() {
		return {
			btnLoading: false,
			//子组件传递对象
			transObj: {
				id: '',
				groupId: '',
				groupName: '',
				parentId: '',
				parentName: '',
				type: '',
			},

			treeObj: {
				loading: false,
				tableH: 200,
				data: [],
			},
			//弹框对象
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add',
			},
		}
	},
	created() {
		this.init()
	},
	methods: {
		init(obj) {
			this.getGroupInnerRoleList()
		},
		getGroupInnerRoleList() {
			let that = this
			let param = {}
			getProjectRoles(param).then((res) => {
				if (res.operationCode == 1) {
					this.treeObj.data = that.$utils.toArrayTree(res.data)

					if (this.treeObj.data.length > 0) {
						this.rowClick(this.treeObj.data[0])
						this.$refs.tree.setCurrentRow(this.treeObj.data[0])
					}
				}
			})
		},
		doClick(obj, type) {
			let that = this
			that.dialogObj.mode = type
			if (type === 'add') {
				//新增
				this.transObj.id = ''
				if (obj != '') {
					//新增子节点
					this.transObj.parentId = obj.id
					this.transObj.parentName = obj.roleName
				} else {
					//新增父角色
					this.transObj.parentId = '0'
					this.transObj.parentName = ''
				}
				this.dialogObj.title = '新增角色'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				//编辑
				this.transObj.id = obj.id
				this.transObj.parentId = ''
				this.transObj.parentName = ''
				this.dialogObj.title = '编辑角色'
				this.dialogObj.visible = true
			} else if (type === 'delete') {
				//删除
				this.delete(obj)
			}
		},
		//删除
		delete(obj) {
			let that = this
			this.$confirm(
				'删除角色信息，将会删除角色菜单、角色菜单按钮、权限数据等信息，确认删除吗?',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			).then(() => {
				let param = {
					id: obj.id,
				}
				deletePlus(param).then((res) => {
					if (res.operationCode == 1) {
						if (res.msg == 'faild') {
							that.$message({ message: res.data, type: 'error' })
							return
						}
						that.$message({ message: '删除成功', type: 'success' })
						this.getGroupInnerRoleList()
						this.$emit('row-click', '')
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},
		//行点击
		rowClick(obj) {
			this.$emit('row-click', obj)
		},
		// 确定按钮事件
		doSave() {
			this.$refs.roleAdd.doSave()
		},
		//新增/编辑菜单成功
		handleSuccess() {
			this.dialogObj.visible = false
			this.getGroupInnerRoleList()
		},
		// 关闭弹窗事件
		handleClose() {},
		cellStyle({ row, column, rowIndex, columnIndex }) {
			let style = {}
			//预设角色
			if (row.roleType == '1007001' && columnIndex == 0)
				style.background = '#EEF2FC'
			return style
		},
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.treeObj.tableH = this.$refs.content.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		clientSize(val) {
			this.treeObj.tableH = this.$refs.content.offsetHeight
		},
	},
}
</script>
<style lang="less"></style>
